import React, { useState, useEffect, useContext } from 'react';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import DataUnavailable from '../../../components/DataUnavailable/index';
import TopNav from '../../../components/TopNav/TopNav';
import {
  getConsumerCheckInCount,
  requestCheckin,
} from '../../../services/NetworkServices';
import { Box, Typography, Modal, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import StyledButton from '../../../components/Button/Button';
import './ConsumerDetails.css';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { TextField, InputAdornment } from '@mui/material';

import { StyledTableCell, StyledTableRow } from '../Dashboard/Dashboard';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';

import CheckinTick from '../../../assets/CheckInGreen Tick.svg';
import CheckinFailure from '../../../assets/cancel icon.png';
import LeftArrow from '../../../assets/Left 1.svg';
import RightArrow from '../../../assets/Arrow narrow right.svg';
import { Pagination } from '@mui/material';
import CalendarIcon from '../../../assets/Calender 1.svg';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { getConsumerDetails } from '../../../services/NetworkServices';
import {
  BabysitterContext,
  BabysitterContextProps,
} from '../../../context/BabysitterContext';
import ConsumerCheckInCounts from '../ConsumerCheckInCounts/ConsumerCheckInCounts';
import ScannedFaceIcon from '../../../assets/download inner.svg';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';
import Popup from '../../../components/Inputs/Popup';
import { approveFace } from '../../../services/NetworkServices';
import { useRef } from 'react';
import DatePickerCustom from '../../../components/Calendar/DatePicker';
import Popupreject from '../../../components/Inputs/Popupreject';
import Popupsuccess from '../../../components/Inputs/Popupsuccess';
import emptyTime from '../../../assets/empty Time.svg';
import CheckinPending from '../../../assets/checkInPending.svg';

interface CheckIn {
  date: string;
  submissions: Submission[];
}

interface Submission {
  checkIn_initiated_time: string;
  checkIn_performed_time: string;
  time: string;
  authentication: string;
  city: string;
  country: string;
  verified: string;
  capturedImage: string;
  uploadedGovtId: string;
  _id: string;
  sublocality_level_1: string;
  sublocality_level_2: string;
  state: string;
  neighborhood: string;
  route: string;
  street_number: string;
}

const today = new Date();
const oneMonthBefore = new Date();
oneMonthBefore.setMonth(today.getMonth() - 1);

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// FilterComponent: Refactored to show buttons in grid layout

const ConsumerDetails = () => {
  const [showScannedFace, setShowScannedFace] = useState<boolean>(false);
  const [showManualVerification, setShowManualVerification] =
    useState<boolean>(false);
  const [scannedFaceDoc, setShowScannedFaceDoc] = useState<string>('');
  const [originalFaceDoc, setOriginalFaceDoc] = useState<string>('');
  const [showApprovedPopup, setShowApprovedPopup] = useState<boolean>(false);
  const [showRejectedPopup, setShowRejectedPopup] = useState<boolean>(false);
  const [approvedSubmissionId, setApprovedSubmissionId] = useState<string>('');
  const [showProfileFace, setShowProfileFace] = useState<boolean>(false);

  const startDatePickerRef = useRef<HTMLButtonElement | null>(null);
  const endDatePickerRef = useRef<HTMLButtonElement | null>(null);

  const [currentPage, setCurrentPage] = useState<number>(1); // Start on page 1
  const itemsPerPage = 5;
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const context = useContext(BabysitterContext) as BabysitterContextProps;
  if (!context) {
    throw new Error(
      'Babysitter Context must be used within a BabysitterProvider',
    );
  }
  const {
    selectedStartDate,
    setStartDate,
    setEndDate,
    selectedEndDate,
    handleStartDateChange,
    handleEndDateChange,
    payload,
    handlePayloadChange,
    checkInsList,
    handleCheckInsList,
    showDatePicker,
    handleShowDatePicker,
    showDatePickerForDownload,
    handleShowDatePickerForDownload,
  } = context;

  const { id } = useParams<{ id: string }>();

  const handleApplyDateFilter = () => {
    if (selectedStartDate && selectedEndDate) {
      const newFilterValue = {
        startDate: formatDate(selectedStartDate),
        endDate: formatDate(selectedEndDate),
      };

      handlePayloadChange({ ...newFilterValue });
      handleShowDatePicker(false);
    }
  };

  // const handleDownload = async () => {
  //   if (selectedStartDate && selectedEndDate) {
  //     const newFilterValue = {
  //       startDate: formatDate(selectedStartDate),
  //       endDate: formatDate(selectedEndDate),
  //     };

  //     handlePayloadChange({ ...newFilterValue });
  //     handleShowDatePickerForDownload(false);

  //     // Call API to fetch new data
  //     await getConsumerCheckInDetails();

  //     // Once the data is fetched, trigger CSV download
  //     initiateDownload();
  //   }
  // };

  // const initiateDownload = () => {
  //   setShouldDownloadCSV(true);
  // };

  // const [shouldDownloadCSV, setShouldDownloadCSV] = useState(false);

  // Trigger CSV download after `checkInsList` has been updated
  // useEffect(() => {
  //   if (shouldDownloadCSV && checkInsList && checkInsList.length > 0) {
  //     const csvRows = [];
  //     csvRows.push(
  //       ["Time", "Check-ins", "Location", "Verified", "Scanned Face"].join(",")
  //     );

  //     checkInsList.forEach((data: any) => {
  //       csvRows.push(data.date);
  //       data.submissions.forEach((item: Submission) => {
  //         csvRows.push(
  //           [
  //             item.time,
  //             "Check-in icon",
  //             `"${item.sublocality_level_1}, ${item.city}, ${item.state}, ${item.country}"`,
  //             "NA",
  //             item.capturedImage,
  //           ].join(",")
  //         );
  //       });
  //     });

  //     const csvString = csvRows.join("\n");

  //     const blob = new Blob([csvString], { type: "text/csv" });
  //     const url = URL.createObjectURL(blob);

  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "checkInData.csv";
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     URL.revokeObjectURL(url);

  //     // Reset the download trigger
  //     setShouldDownloadCSV(false);
  //   }
  // }, [shouldDownloadCSV, checkInsList]);

  const getFormattedAddress = (item: Submission) => {
    let address = '';
    if (item?.street_number) {
      address += item?.street_number + ',';
    }
    if (item?.route) {
      address += item?.route + ',';
    }
    if (item?.neighborhood) {
      address += item?.neighborhood + ',';
    }
    if (item?.sublocality_level_1) {
      address += item?.sublocality_level_1 + ',';
    }
    if (item?.sublocality_level_2) {
      address += item?.sublocality_level_2 + ',';
    }
    if (item?.city) {
      address += item?.city + ',';
    }
    if (item?.state) {
      address += item?.state + ',';
    }
    if (item?.country) {
      address += item?.country;
    }

    return address || 'No Location';
  };

  const handleDownload = async () => {
    if (selectedStartDate && selectedEndDate) {
      const newFilterValue = {
        startDate: formatDate(selectedStartDate),
        endDate: formatDate(selectedEndDate),
      };

      handlePayloadChange({ ...newFilterValue });
      handleShowDatePickerForDownload(false);
      setStartDate(null);
      setEndDate(null);
      if (!id) {
        console.error('ID is undefined');
        return;
      }
      const response = await getConsumerDetails(id, {
        ...newFilterValue,
      });
      const data = await response.data;

      if (response) {
        if (!checkInsList || checkInsList.length === 0) return;

        const csvRows = [];
        csvRows.push(
          [
            'Requested Check-in Time',
            'Actual Check-in Time',
            'Check-ins',
            'Location',
            'Verified',
            'Scanned Face',
          ].join(','),
        );

        const filteredCheckInsListByDate = data.data.paginatedResults.map(
          (checkIn: CheckIn) => ({
            date: checkIn.date,
            submissions: checkIn.submissions,
          }),
        );
        filteredCheckInsListByDate.forEach((data: any) => {
          csvRows.push(data.date);
          data.submissions.forEach((item: Submission) => {
            csvRows.push(
              [
                item.checkIn_initiated_time,
                item.checkIn_performed_time || 'NA',
                item.authentication,
                getFormattedAddress(item),
                item.authentication,
                item.capturedImage || 'NA',
              ].join(','),
            );
          });
        });

        const csvString = csvRows.join('\n');

        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'checkInData.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    }
  };

  const handleApproval = async (value: string) => {
    const response = await approveFace(value);
    const data = await response.data;
    if (data) {
      setShowApprovedPopup(true);
    }
  };
  const handleShowScannedFace = (value: string) => {
    setShowScannedFace(true);
    setShowScannedFaceDoc(value);
  };

  const handleManualVerification = (
    value1: string,
    value2: string,
    value3: string,
  ) => {
    console.log(value1, 'value1');
    console.log(value2, 'value2');
    console.log(value3, 'value3');

    setShowManualVerification(!showManualVerification);
    setOriginalFaceDoc(value2);
    setShowScannedFaceDoc(value1);
    setApprovedSubmissionId(value3);
  };

  const backClick = () => {
    setShowScannedFace(false);
    setShowManualVerification(false);
  };

  const handleContinue = () => {
    setShowApprovedPopup(false);
    getConsumerCheckInDetails();
    setShowManualVerification(false);
  };

  const handleDoneAfterReject = () => {
    setShowRejectedPopup(false);

    setShowManualVerification(false);
  };
  const getConsumerCheckInDetails = async () => {
    if (id) {
      try {
        console.log('payload is', payload);
        const response = await getConsumerDetails(
          id,
          payload,
          currentPage,
          itemsPerPage,
        );
        const data = response.data;
        setTotalRecords(data.data.totalCount);
        const filteredCheckInsListByDate = data.data.paginatedResults.map(
          (checkIn: CheckIn) => ({
            date: checkIn.date,
            submissions: checkIn.submissions,
          }),
        );

        handleCheckInsList(filteredCheckInsListByDate);
      } catch (error) {
        console.error('Error fetching check-in count:', error);
      }
    } else {
      console.error('ID is undefined');
      return false; // Indicate failure
    }
  };

  const handleDatePicekerClose = () => {
    handleShowDatePickerForDownload(false);
    setStartDate(null);
    setEndDate(null);
  };
  // Update payload when filter changes

  useEffect(() => {
    getConsumerCheckInDetails();
  }, [payload, currentPage]); // Trigger API call on payload change

  console.log(originalFaceDoc, scannedFaceDoc, 'rrr');

  return (
    <>
      <StyledBgContainer>
        {!showScannedFace && !showManualVerification && (
          <>
            {!showProfileFace && <TopNav showArrow={true} />}

            <ConsumerCheckInCounts
              showProfileFace={showProfileFace}
              setShowProfileFace={setShowProfileFace}
            />
            {!showProfileFace && (
              <Box sx={{ px: { xs: 1, sm: 10 } }}>
                <TableContainer
                  component={Paper}
                  sx={{
                    background: `linear-gradient(rgb(23, 24, 30), rgb(29, 31, 41)) padding-box,
                  linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box`,
                    border: '1.4px solid transparent',
                    borderRadius: '10px',
                    width: '100vws',
                    marginTop: '5vh',
                  }}
                >
                  <Table sx={{ color: 'white' }}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell sx={{ width: '10%' }}>
                          Requested <br /> Check-in Time
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }}>
                          Actual <br /> Check-in Time
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '11%' }}>
                          Check-ins
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '20%' }}>
                          Location
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '14%' }}>
                          Verified
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '14%' }}>
                          Scanned Face
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ color: 'white' }}>
                      {checkInsList && checkInsList.length > 0 ? (
                        checkInsList.map((checkIn, checkInIndex) => (
                          <React.Fragment key={checkInIndex}>
                            {/* Render Submission Rows */}
                            {checkIn.submissions.map(
                              (
                                submission: Submission,
                                submissionIndex: number,
                              ) => (
                                <StyledTableRow
                                  key={submissionIndex}
                                  sx={{
                                    backgroundColor:
                                      (checkInIndex + submissionIndex) % 2 === 0
                                        ? 'rgba(96, 111, 140, 0.08)'
                                        : 'black', // Alternate styling
                                    color: 'white !important',
                                  }}
                                >
                                  <StyledTableCell sx={{ color: 'white' }}>
                                    <p>
                                      {submission.checkIn_initiated_time ? (
                                        submission.checkIn_initiated_time
                                      ) : (
                                        <img src={emptyTime} alt="emptyTime" />
                                      )}
                                    </p>
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ color: 'white' }}>
                                    <p>
                                      {submission.checkIn_performed_time ? (
                                        submission.checkIn_performed_time
                                      ) : (
                                        <img src={emptyTime} alt="emptyTime" />
                                      )}
                                    </p>
                                  </StyledTableCell>

                                  <StyledTableCell sx={{ color: 'white' }}>
                                    {submission.authentication === 'Pending' ? (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <img
                                          src={CheckinPending}
                                          alt="checkin tick"
                                          style={{
                                            width: '25px',
                                            height: '25px',
                                            opacity: '0.5',
                                            marginLeft: '10px',
                                            marginRight: '10px',
                                          }}
                                        />
                                      </div>
                                    ) : submission.authentication ===
                                      'Success' ? (
                                      <img
                                        src={CheckinTick}
                                        alt="checkin tick"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={CheckinFailure}
                                        alt="checkin failure tick"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                        }}
                                      />
                                    )}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ color: 'white' }}>
                                    {submission.street_number &&
                                      submission.street_number + ' , '}
                                    {submission.route &&
                                      submission.route + ' , '}
                                    {submission.neighborhood &&
                                      submission.neighborhood + ' , '}
                                    {submission.sublocality_level_1 &&
                                      submission.sublocality_level_1 + ' , '}
                                    {submission.city && submission.city + ' , '}
                                    {submission.state &&
                                      submission.state + ' , '}
                                    {submission.country && submission.country}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ color: 'white' }}>
                                    {submission.authentication === 'Pending' ? (
                                      <img
                                        src={CheckinPending}
                                        alt="checkin tick"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                          opacity: '0.5',
                                          marginLeft: '10px',
                                          marginRight: '10px',
                                        }}
                                      />
                                    ) : submission.authentication ===
                                      'Success' ? (
                                      <img
                                        src={CheckinTick}
                                        alt="checkin tick"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '8px',
                                        }}
                                      >
                                        <img
                                          src={CheckinFailure}
                                          alt="checkin failure tick"
                                          style={{
                                            width: '25px',
                                            height: '25px',
                                          }}
                                        />
                                        <button
                                          onClick={() =>
                                            handleManualVerification(
                                              submission.capturedImage,
                                              submission.uploadedGovtId,
                                              submission._id,
                                            )
                                          }
                                          className="view-id"
                                        >
                                          Verify Manually
                                        </button>
                                      </div>
                                    )}
                                    {/* {submission.authentication === 'Success' ? (
                                      <img
                                        src={CheckinTick}
                                        alt="checkin tick"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                        }}
                                      />
                                    ) : (
                                      <Box
                                        gap={1}
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          justifyContent: 'start',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <img
                                          src={CheckinFailure}
                                          alt="checkin failure tick"
                                          style={{
                                            width: '25px',
                                            height: '25px',
                                          }}
                                        />
                                        <button
                                          onClick={() =>
                                            handleManualVerification(
                                              submission.capturedImage,
                                              submission.uploadedGovtId,
                                              submission._id,
                                            )
                                          }
                                          className="view-id"
                                        >
                                          Verify Manually
                                        </button>
                                      </Box>
                                    )} */}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ color: 'white' }}>
                                    <Box
                                      sx={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '50%',
                                        backgroundColor: 'orangered',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <img
                                        src={ScannedFaceIcon}
                                        alt="Scanned Face"
                                        onClick={() =>
                                          handleShowScannedFace(
                                            submission.capturedImage,
                                          )
                                        }
                                      />
                                    </Box>
                                  </StyledTableCell>
                                </StyledTableRow>
                              ),
                            )}
                            {/* Render Date Row */}
                            <StyledTableRow>
                              <StyledTableCell
                                colSpan={6}
                                sx={{ textAlign: 'center' }}
                              >
                                <Divider
                                  variant="middle"
                                  sx={{
                                    '&::before, &::after': {
                                      borderColor: 'white',
                                      borderStyle: 'dashed',
                                      borderWidth: '1px',
                                      flex: 1,
                                    },
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Chip
                                    label={checkIn.date}
                                    sx={{
                                      backgroundColor: 'white',
                                      color: 'black',
                                    }} // Customize button look
                                  />
                                </Divider>
                              </StyledTableCell>
                            </StyledTableRow>
                          </React.Fragment>
                        ))
                      ) : (
                        <StyledTableCell colSpan={6}>
                          <DataUnavailable description="No record found" />
                        </StyledTableCell>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {totalRecords > 5 && (
              <div className="table_pagination_container">
                <div
                  className="pagination-btn-wrapper"
                  onClick={handlePreviousPage}
                >
                  <img src={LeftArrow} alt="Previous" /> Previous
                </div>
                <div>
                  <Pagination
                    count={Math.ceil(totalRecords / itemsPerPage)} // Use dynamic page count
                    page={currentPage} // Controlled page value
                    onChange={(e, value) => setCurrentPage(value)} // Update page on pagination change
                    color="primary"
                    sx={{
                      '& .MuiPaginationItem-root': {
                        color: '#FFFFFF66', // Default color for other pages
                      },
                      '& .Mui-selected': {
                        // Background for selected page
                        color: 'white', // Text color for selected page
                      },
                    }}
                  />
                </div>
                <div
                  className="pagination-btn-wrapper"
                  onClick={handleNextPage}
                >
                  Next <img src={RightArrow} alt="Next" />
                </div>
              </div>
            )}
          </>
        )}
        {showScannedFace && (
          <>
            <TopNav
              showArrow={true}
              backRoute={`/supervisor/Details/${id}`}
              backClick={backClick}
            />
            <img
              src={scannedFaceDoc}
              style={{
                height: '80vh',
                width: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
                objectFit: 'cover',
              }}
              alt="Scanned Face"
            />
          </>
        )}
        {showManualVerification && (
          <>
            {/* TOP Nav */}
            <TopNav
              showArrow={true}
              backRoute={`/babysitter/consumerDetails/${id}`}
              backClick={backClick}
            />

            <>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="start"
                minHeight="100vh"
                sx={{
                  padding: '0 1rem',
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{
                    flexDirection: { xs: 'column', md: 'row' }, // Stack vertically on small screens, row layout on larger screens
                    width: '100%',
                    justifyContent: 'center',
                    gap: { xs: '2rem', md: 0 }, // Space between boxes on small screens
                  }}
                >
                  {/* Original Face */}
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{
                      marginRight: { xs: 0, md: 6 },
                      marginBottom: { xs: 4, md: 0 }, // Add margin for spacing on small screens
                      gap: 4,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="white"
                      marginBottom={2}
                      sx={{ fontFamily: 'Opensans', fontWeight: '600' }}
                    >
                      Original Face
                    </Typography>
                    <Box
                      component="img"
                      src={originalFaceDoc}
                      alt="Original Face"
                      width={{ xs: 200, sm: 250, md: 300 }}
                      height={{ xs: 300, sm: 350, md: 350 }} // Auto height for small screens
                      borderRadius={4}
                      sx={{ objectFit: 'contain' }}
                    />
                  </Box>

                  {/* White Border */}
                  <Box
                    sx={{
                      display: { xs: 'none', md: 'block' }, // Hide border on small screens
                      width: '1px',
                      height: { xs: 'auto', md: '400px' }, // Border height responsive
                      bgcolor: 'white',
                      marginRight: 2,
                      marginLeft: 2,
                    }}
                  />

                  {/* Scanned Face */}
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{
                      marginLeft: { xs: 0, md: 6 }, // Remove margin on small screens
                      gap: 4,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="white"
                      marginBottom={2}
                      sx={{ fontFamily: 'Opensans', fontWeight: '600' }}
                    >
                      Scanned Face
                    </Typography>
                    <Box
                      component="img"
                      src={scannedFaceDoc}
                      alt="Scanned Face"
                      // width={{ xs: 200, sm: 250, md: 300 }}
                      // height={{ xs: 300, sm: 350, md: 350 }} // Auto height for small screens
                      borderRadius={4}
                      sx={{
                        objectFit: 'contain',
                        width: '300px',
                        height: '350px',
                      }}
                    />
                  </Box>
                </Box>

                {/* Buttons */}
                <Box
                  display="flex"
                  justifyContent="center"
                  marginTop={4}
                  gap={2}
                  sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
                >
                  <Button
                    sx={{
                      letterSpacing: '1px',
                      color: '#FB5012',
                      backgroundColor: 'transparent',
                      border: '2px solid #FB5012',
                      textTransform: 'none',
                      fontFamily: 'Opensans',
                      fontWeight: '400',
                      padding: '11px 28px',
                      borderRadius: '38px',
                    }}
                    onClick={() => setShowRejectedPopup(true)}
                  >
                    <strong>Reject</strong>
                  </Button>
                  <StyledButton
                    onClick={() => handleApproval(approvedSubmissionId)}
                  >
                    Approve
                  </StyledButton>
                </Box>
              </Box>
            </>
            {showApprovedPopup && (
              <Popupsuccess
                title={
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: 'opensans',
                      fontWeight: '700',
                      lineHeight: '1.4',
                    }}
                  >
                    {' '}
                    Scanned Face <br /> Approved Successfully{' '}
                  </Typography>
                }
                message={
                  <Typography variant="body2">
                    {' '}
                    Your face scan has been successfully approved. Thank you for
                    your submission!
                  </Typography>
                }
                buttonText="Done"
                onButtonClick={handleContinue}
              />
            )}
            {showRejectedPopup && (
              <Popupreject
                title={
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: 'opensans',
                      fontWeight: '700',
                      lineHeight: '1.4',
                    }}
                  >
                    {' '}
                    Scanned Face <br /> Rejected Successfully{' '}
                  </Typography>
                }
                message={
                  <Typography variant="body2">
                    {' '}
                    Your face scan has been rejected. Please ensure that the
                    scan is clear and try again.
                  </Typography>
                }
                buttonText="Done"
                onButtonClick={handleDoneAfterReject}
              />
            )}
          </>
        )}

        <Modal
          open={showDatePicker}
          onClose={() => handleShowDatePicker(false)}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '39%',
              left: '50%',
              transform: 'translate(-50%, -50%)', // Center the modal horizontally and vertically
              width: { xs: '90%', sm: '75%', md: '60%', lg: '43%' }, // Responsive width
              maxWidth: '100vw', // Ensure modal doesn't overflow horizontally
              maxHeight: '90vh', // Prevent vertical overflow
              overflowY: 'auto', // Add scroll for overflow content
              bgcolor: 'transparent', // Background color
              padding: { xs: 2, sm: 3, md: 3 }, // Responsive padding
              borderRadius: 2,
              outline: 'none', // Remove default outline
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#7D7D7D',
                padding: { xs: '12px', sm: '20px' }, // Slightly increase padding for better spacing
                marginBottom: { xs: '5vh', md: '8vh' }, // Adjusting margin for small screens
                borderRadius: '20px',
                borderColor: '#365F91',
                border: '1.4px solid transparent',
                background: `
              linear-gradient(#2C2F33, #2C2F33) padding-box,
              linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
            `,
                borderImageSlice: 1,
                width: '100%', // Ensure the box takes up the full width of the modal
              }}
            >
              <Typography
                mb={2}
                sx={{
                  color: 'white',
                  fontSize: { xs: '16px', sm: '18px' },
                  textAlign: 'left', // Center text for better responsiveness
                }}
              >
                Select Period
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' }, // Stacks vertically on small screens, horizontally on larger ones
                  gap: { xs: '10px', sm: '8px' }, // Responsive gap between date pickers
                  alignItems: 'center', // Centers the items vertically
                  justifyContent: { xs: 'center', sm: 'space-between' }, // Ensure space between date pickers on larger screens
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <CustomDatePicker
                    label="From"
                    selectedDate={selectedStartDate}
                    onDateChange={handleStartDateChange}
                    calendarIcon={CalendarIcon}
                  />
                  <CustomDatePicker
                    label="To"
                    selectedDate={selectedEndDate}
                    onDateChange={handleEndDateChange}
                    calendarIcon={CalendarIcon}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <StyledButton onClick={handleApplyDateFilter}>Apply</StyledButton>
          </Box>
        </Modal>
        <Modal
          open={showDatePickerForDownload}
          // onClose={() => handleShowDatePickerForDownload(false)}
          onClose={handleDatePicekerClose}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)', // Center the modal horizontally and vertically
              width: { xs: '90%', sm: '75%', md: '60%', lg: '43%' }, // Responsive width
              maxWidth: '100vw', // Ensure modal doesn't overflow horizontally
              maxHeight: '90vh', // Prevent vertical overflow
              overflowY: 'auto', // Add scroll for overflow content
              bgcolor: 'transparent', // Background color
              padding: { xs: 2, sm: 3, md: 3 }, // Responsive padding
              borderRadius: 2,
              outline: 'none', // Remove default outline
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#7D7D7D',
                padding: { xs: '12px', sm: '20px' }, // Slightly increase padding for better spacing
                marginBottom: { xs: '5vh', md: '8vh' }, // Adjusting margin for small screens
                borderRadius: '20px',
                borderColor: '#365F91',
                border: '1.4px solid transparent',
                background: `
              linear-gradient(#2C2F33, #2C2F33) padding-box,
              linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
            `,
                borderImageSlice: 1,
                width: '100%', // Ensure the box takes up the full width of the modal
              }}
            >
              <Typography
                mb={2}
                sx={{
                  color: 'white',
                  fontSize: { xs: '16px', sm: '18px' },
                  textAlign: 'left', // Center text for better responsiveness
                }}
              >
                Select Duration
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' }, // Stacks vertically on small screens, horizontally on larger ones
                  gap: { xs: '10px', sm: '8px' }, // Responsive gap between date pickers
                  alignItems: 'center', // Centers the items vertically
                  justifyContent: { xs: 'center', sm: 'space-between' }, // Ensure space between date pickers on larger screens
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <CustomDatePicker
                    label="From"
                    selectedDate={selectedStartDate}
                    onDateChange={handleStartDateChange}
                    calendarIcon={CalendarIcon}
                  />
                  <CustomDatePicker
                    label="To"
                    selectedDate={selectedEndDate}
                    onDateChange={handleEndDateChange}
                    calendarIcon={CalendarIcon}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <StyledButton
              sx={{
                marginTop: { xs: '16px', sm: '24px' }, // Adjusts spacing between button and the date picker container
                width: { xs: '100%', sm: 'auto' }, // Full-width button on small screens, auto width on larger
              }}
              onClick={handleDownload}
            >
              Download
            </StyledButton>
          </Box>
        </Modal>

        {/*<DatePickerCustom/>*/}
      </StyledBgContainer>
    </>
  );
};

export default ConsumerDetails;
